import { formatPhone } from '@helpers/dateFormation';

export const PhoneCentre = (phone): string => {
  return phone
    ? `
        <div class="balloon__phone mobile">
          <a href="tel:${formatPhone(phone)}">
            ${formatPhone(phone)}
          </a>
        </div>
        `
    : '';
};
